/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */

import firebase from 'firebase';
import requests from './requests';

export const rolesType = {
  admin: 'Administrador',
  sampler: 'Coletor',
  technician: 'Técnico',
  // patient: 'Paciente',
};

const maxResults = 15;
const MIN_EMAIL_LENGTH_SEARCH = 3;

export const getCustomToken = async (uid) => {
  const jwt = await firebase.auth().currentUser.getIdToken();
  try {
    const response = await requests.get(`/customToken/${uid}`, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    });
    return response.data;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
  }

  return null;
};

export const getAllUsers = async (pageToken = null) => {
  try {
    const token = await firebase.auth().currentUser.getIdToken();
    return await requests.get('/dataUserList', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        maxResults,
        pageToken,
      },
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
  }

  return null;
};

export const getByEmail = async (email) => {
  if (email?.length < MIN_EMAIL_LENGTH_SEARCH) {
    return null;
  }

  try {
    const token = await firebase.auth().currentUser.getIdToken();
    return await requests.get(`/searchUsers?text=${email}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
  }

  return null;
};

const updateEmail = async (id, email) => {
  try {
    const token = await firebase.auth().currentUser.getIdToken();
    const response = await requests.post(`/changeUserEmail/${id}`, { email }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
  }

  return null;
};

export const updateUser = async (id, { email/* , fullname, professionalCouncil */ }) => {
  if (email) {
    const result = await updateEmail(id, email);
    return result;
  }

  return null;
  /*
    FIXME update professionalCouncil or fullname or anything else from firestore.
    I commented this because there are some users we don't have in firestore but only in auth;
    so we can't update any data there.
  */

  /* try {
    let newData = {};
    const userRef = firebase.firestore().collection('users').doc(id);

    if (professionalCouncil !== undefined) {
      newData.professionalCouncil = professionalCouncil;
    }
    if (fullname !== undefined) {
      newData.fullname = fullname;
    }

    await userRef.set(newData);
  } catch (error) {
    console.log(`ERROR UPDATING USER ${id}`, error);
    return false;
  }
  return true; */
};

export const updateRole = async (user, roles) => {
  const db = firebase.firestore();
  const updatedBy = firebase.auth().currentUser.uid;

  const promises = roles.map(async (role) => {
    if (role.value) {
      const userInRole = await db.collection(`roles/${role.id}/users`).doc(user.id).get();
      if (!user.roles) {
        user.roles = [];
      }
      if (!userInRole.exists) {
        try {
          await db.collection(`roles/${role.id}/users`).doc(user.id).set({
            Email: user.email,
            createdAt: firebase.firestore.Timestamp.now(),
            updatedBy,
          });
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(`Error trying to ADD user '${user.id}' to role '${role.id}'`, error);
          return user;
        }
        user.roles.push(role.id);
      }
      return null;
    }
    try {
      await db.collection(`roles/${role.id}/users`).doc(user.id).delete();
      user.roles.splice(user.roles.indexOf(role.name), 1);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(`Error trying to DELETE user '${user.id}' from role '${role.id}'`, error);
      return user;
    }
    return user;
  });

  await Promise.all(promises);
  return user;
};

const getUserRole = async (uid) => {
  const db = firebase.firestore();
  const roleList = [];

  const checkRole = Object.keys(rolesType).map(async (role) => {
    try {
      const doc = await db.collection(`roles/${role}/users`).doc(uid).get();
      if (doc.exists) {
        roleList.push(rolesType[role]);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(role, error);
    }
  });

  await Promise.all(checkRole);
  return roleList;
};

export const getUserInfo = async (email, id) => {
  const db = firebase.firestore();
  let user = {};

  try {
    const doc = await db.collection('users').doc(id).get();
    if (doc.exists) {
      user = doc.data();
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
  }

  const roles = await getUserRole(id);
  user = {
    ...user, id, email, roles,
  };

  return user;
};
